export enum DIALOGS {
    PERSISTENCE_AVATAR = 'PERSISTENCE_AVATAR',
    PERSISTENCE_COVER = 'PERSISTENCE_COVER',
    SAVE_TO_COLLECTION_DIALOG_NAME = 'saveToCollection',
    DELETE_FROM_COLLECTION_DIALOG_NAME = 'deleteFromCollection',
    SUBSCRIPTIONS = 'SUBSCRIPTIONS',
    EDIT_COLLECTION = 'EDIT_COLLECTION',
    CREATE_INVITE = 'CREATE_INVITE',
    REPORT_DIALOG = 'REPORT_DIALOG',
    OFFER_AGREEMENT = 'OFFER_AGREEMENT,',
    WITHOUT_RANGE = 'WITHOUT_RANGE',
    SELECT_CATEGORIES = 'SELECT_CATEGORIES',
    POST_PRODUCTS = 'POST_PRODUCTS',
}

export const DEFAULT_CLOSE_ANIMATION_DELAY = 150;
